
const Locale = function(translations) {
    this.translations = translations;
};

Locale.prototype = {
    /**
         * Translate string by key from translation dictionary
         * Return translated key or substitute (if provided) or key itself
         * @param key
         * @returns {*}
         */
    translate: function(key, substitute) {
        // typeof to check keys like "0"
        return this.translations[key] || (typeof substitute === 'undefined' ? key : substitute);
    },

    /**
         * Get localized month name
         * Returns month number if translation is not found
         *
         * @param date
         * @returns {*|number}
         */
    getMonthName: function(date) {
        const months = this.translations.months || [];

        return months[date.getMonth()] || date.getMonth();
    }
};

export default Locale;
